import React from "react";
import { FormCheckbox } from "../../../forms/FormCheckbox/FormCheckbox";
import { Counterparty } from "../../../../common/types/counterparty";
import styles from "./CounterpartyFilter.module.scss";
import { CounterpartiesFilters, NO_COUNTERPARTY_LABEL } from "./lib";

interface Props {
    counterparty: Counterparty | null;
    filters: CounterpartiesFilters;
    handleChange: (value: string) => void;
}

export const CounterpartyFilterRow: React.FC<Props> = ({
    counterparty,
    filters,
    handleChange,
}) => (
    <FormCheckbox
        value={counterparty?.id ?? ""}
        isChecked={Boolean(
            counterparty?.id
                ? filters.counterpartiesIds?.includes(counterparty.id)
                : filters.withEmptyOrUnverifiedCounterparty,
        )}
        handleChange={handleChange}
        className={styles.checkbox}
        small
        label={counterparty?.name ?? NO_COUNTERPARTY_LABEL}
    />
);
